/**
 * Pix manual com chave "QR Code na maquininha": pagamento PRESENCIAL
 *
 * ## Por que existe
 *
 * O Pix manual (`paymentMethod === 'pix'`) tem vários tipos de chave, e um deles não é
 * Pix à distância nenhum: `qrcode-in-machine`. O QR Code está na maquininha do
 * estabelecimento, então o consumidor só paga na hora da entrega ou da retirada — como
 * dinheiro e cartão. Não existe pagamento a ser feito no fechamento do pedido, nem
 * comprovante a ser enviado, nem chave a ser copiada.
 *
 * A tela de sucesso classificava esse pedido como pagamento online só porque o método é
 * `pix`, e mostrava "Aguardando pagamento" com o pedido de comprovante (OP-1046). O
 * consumidor lia que precisava pagar antes, procurava a loja para tirar a dúvida e às
 * vezes abandonava o pedido.
 *
 * ## Por que a regra mora aqui
 *
 * A mesma condição decide coisas em lugares que não se conhecem: a tela de sucesso do
 * layout novo, a do layout legado e o texto do pedido no WhatsApp. Quando cada um
 * escrevia `paymentMethod === 'pix' && key_type === 'qrcode-in-machine'` na mão, mapear
 * metade dos casos falhava em silêncio — foi assim que a tela nova já tinha a mensagem
 * certa enquanto a moldura continuava dizendo "Aguardando pagamento".
 *
 * Uma função só, sem dependência de Angular, testável direto.
 */

/** Valor do `key_type` que o backend manda para o QR Code que fica na maquininha. */
export const PIX_KEY_TYPE_IN_MACHINE = 'qrcode-in-machine';

/**
 * É Pix manual pago na maquininha do estabelecimento (na entrega/retirada)?
 *
 * Só o Pix MANUAL (`pix`) tem tipo de chave. `pixAsaas` e `pixTuna` são Pix online de
 * verdade — pagos antes, com confirmação automática — e nunca entram aqui.
 */
export function isPixPaidInMachine(paymentMethod?: string, keyType?: string): boolean {
	return paymentMethod === 'pix' && keyType === PIX_KEY_TYPE_IN_MACHINE;
}

/**
 * Chave de tradução do aviso que informa QUANDO o Pix será pago.
 *
 * O pedido é confirmado na hora, mas o consumidor ainda precisa saber que vai pagar na
 * maquininha — o critério de aceite do OP-1046 pede o aviso na tela de finalização.
 * A frase muda com o tipo de entrega: quem retira não recebe nada "na entrega".
 */
export function pixInMachineNoticeKey(deliveryType?: string): string {
	return deliveryType === 'delivery'
		? 'You will make the payment at the card machine at the time of delivery'
		: 'You will make the payment at the card machine at the time of pickup';
}
